import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const ProductsContainerStyles = {
    marginBottom: pxToRem(50),
    '.slick-dots': {
        li: {
            margin: 0
        }
    },
    '.slick-next, .slick-prev': {
        svg: {
            stroke: 'black'
        }
    },
    '.slick-track': {
        display: 'flex',
        '.slick-slide': {
            width: '50%',
            marginLeft: pxToRem(15),
            [`@media (min-width: ${size.md})`]: {
                marginLeft: 0
            }
        }
    },
    '.slick-arrow': {
        position: 'absolute',
        top: '25%',
        opacity: 1
    }
}

export const ProductTileStyles = {
    fontFamily: fonts.primary,
    '.product-tile': {
        width: pxToRem(158),
        [`@media (min-width: ${size.md})`]: {
            width: pxToRem(293),
            marginLeft: pxToRem(40),
            maxWidth: pxToRem(290)
        },
        '.product-image': {
            img: {
                height: pxToRem(158),
                width: pxToRem(158),
                [`@media (min-width: ${size.md})`]: {
                    height: pxToRem(290),
                    width: pxToRem(290)
                }
            }
        }
    },
    '.custom-action-button': {
        position: 'absolute',
        padding: pxToRem(14),
        backgroundColor: 'cav_brown',
        color: 'white',
        border: 'none',
        opacity: 0,
        width: '100%',
        pointerEvents: 'none',
        fontSize: pxToRem(14),
        fontWeight: 700,
        zIndex: 10,
        textTransform: 'uppercase',
        fontFamily: fonts.primary,
        display: 'none',
        _hover: {
            backgroundColor: 'white',
            color: 'cav_brown'
        },
        [`@media (min-width: ${size.md})`]: {
            display: 'block'
        }
    },
    '.product-name': {
        marginTop: pxToRem(55),
        textAlign: 'center',
        fontSize: pxToRem(12),
        a: {
            color: 'black'
        },
        [`@media (min-width: ${size.md})`]: {
            fontSize: pxToRem(13)
        }
    },

    '.product-pricing': {
        textAlign: 'center',
        marginTop: pxToRem(25),
        marginBottom: pxToRem(25),
        '.originalPrice, .product-standard-price, .product-sales-price': {
            fontSize: pxToRem(12),
            [`@media (min-width: ${size.md})`]: {
                fontSize: pxToRem(13)
            }
        },
        '.product-sales-price': {
            color: 'cav_hover_brightred'
        }
    },

    '.product-swatches': {
        ul: {
            display: 'flex',
            listStyle: 'none',
            gap: pxToRem(8),
            flexWrap: 'wrap',
            [`@media (min-width: ${size.md})`]: {
                gap: pxToRem(18)
            },
            li: {
                img: {
                    height: pxToRem(36),
                    width: pxToRem(36)
                }
            }
        }
    }
}
